import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_auto_email_eligible_dock_appointmentsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { dock_appointment_carrier_id?: number, projectId?: number, from_date?: string, dock_appointment_type_id?: number, $top?: number, $skip?: number }): Promise<{ result?: { dock_appointment_id?: number, lookup_code?: string, warehouse_id?: number }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_auto_email_eligible_dock_appointments/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { dock_appointment_carrier_id?: number, projectId?: number, from_date?: string, dock_appointment_type_id?: number, $keys: number[] }): Promise<{ result?: { dock_appointment_id?: number, lookup_code?: string, warehouse_id?: number }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_auto_email_eligible_dock_appointments/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      dock_appointment_carrier_id?: number, projectId?: number, from_date?: string, dock_appointment_type_id?: number    }) {
      return false;
    }
}
